import { useRefresh } from "react-admin";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Student } from "../providers/studentsProvider";
import { DialogCloseButton } from "../misc/DialogCloseButton";
import { cancelDunningProcess } from "../api/backend.api";
import { DialogProps } from "../misc/DialogProps";

export function CancelDunningProcessDialog({
  open,
  student,
  onClose,
}: DialogProps & {
  student: Student;
}) {
  const refresh = useRefresh();

  const cancel = async () => {
    try {
      await cancelDunningProcess(student.dunningProcess!.id);
      showSuccessToast("Der Dunning-Prozess wurde abgebrochen.");
      refresh();
      onClose();
    } catch (error) {
      showErrorToast("Fehler beim Abbrechen des Dunning-Prozesses.");
      console.error("Failed to cancel dunning process:", error);
    }
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm">
      <DialogTitle>Prozess abbrechen?</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent>
        <DialogContentText>
          Möchtest du den Prozess stoppen? Der Fahrschüler landet dann wieder im Status “Offene Beträge“.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <LoadingButton size="small" variant="contained" onClick={cancel}>
          Ja, Prozess abbrechen
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
